import '.by{position:relative;}.ssr-plugin'
import '.i0{width:64px;}.ssr-plugin'
import '.i1{height:64px;}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.d{position:absolute;}.ssr-plugin'
import '.i2{bottom:-4px;}.ssr-plugin'
import '.c9{right:-4px;}.ssr-plugin'
import '.ds{border-radius:50%;}.ssr-plugin'
import '.i3{border:2px solid var(--shades-white);}.ssr-plugin'
import '.h{overflow:hidden;}.ssr-plugin'
import '.i4{width:32px;}.ssr-plugin'
import '.i5{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="by i0 i1 bn"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="d i2 c9 ds i3 h i4 i5"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
